<ng-template [ngIf]="config">
  <div class="footer-links" [ngClass]="config.class">
    <ng-template [ngIf]="config.links.length > 0">
      <ng-container *ngFor="let link of config.links">
        <a *ngIf="link.url" margin-horizontal (click)="gatemanService.routeHub(link.url, {target: '_blank'})">
          {{link.text | multiLang}}
        </a>
      </ng-container>
    </ng-template>


    <a (click)="gatemanService.routeHub('https://smartlabel.org/contact-us/')">{{ smartlabelFeedback | multiLang}}</a>
  </div>
</ng-template>